import React, { useState } from "react";
import GoogleChart from "./GoogleChart";
import NorthEastMap from "./NorthEastMap";
import ProfitChart from "./ProfitChart";
import GenerationDoughnut from "./GenerationDoughnut";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import PowerShareChart from "./PowerShareChart";

const ChartMap = () => {
  const { getText } = useLanguageTranslation();

  const [mapTabsStr, setMapTabsStr] = useState("map");
  const [mapTabsStr1, setMapTabsStr1] = useState("pow");

  const animation = {
    animation: "fadeIn 1s",
  };

  return (
    <>
      <div className="new-tabs-area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 printmap1">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                  <ul className="nav nav-pills home-customtab">
                    {/* <li className="nav-item" role="presentation">
                      <a
                        title={getText(
                          "Power Share in N.E.",
                          "पूर्वोत्तर में पावर शेयर",
                        )}
                        className={`nav-link ${
                          mapTabsStr === "pieChart" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#hydro"
                        role="tab"
                        aria-selected={mapTabsStr === "pieChart"}
                        aria-controls="panel-pieChart"
                        onClick={(e) => {
                          e.preventDefault();
                          setMapTabsStr("pieChart");
                        }}
                      >
                        {getText(
                          "Power Share of NEEPCO in NE",
                          "पूर्वोत्तर में नीपको की बिजली हिस्सेदारी",
                        )}
                      </a>
                    </li> */}
                    <li className="nav-item" role="presentation">
                      <a
                        id="tab-map"
                        title={getText("Generation", "उत्पादन")}
                        className={`nav-link ${
                          mapTabsStr === "map" ? "active" : ""
                        }`}
                        role="tab"
                        data-bs-toggle="pill"
                        href="#hydro"
                        aria-selected={mapTabsStr === "map"}
                        aria-controls="panel-map"
                        onClick={(e) => {
                          e.preventDefault();
                          setMapTabsStr("map");
                        }}
                      >
                        {/* {getText(
                          "NEEPCO POWER GENERATION CHART",
                          "नीपको विद्युत उत्पादन चार्ट",
                        )} */}
                        {getText(
                          "Breakup of NEEPCO’s installed capacity",
                          "नीपको के स्थापित क्षमता का विवरण",
                        )}
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        id="tab-barChart"
                        title={getText("Profits", "लाभ")}
                        className={`nav-link ${
                          mapTabsStr === "barChart" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#hydro"
                        role="tab"
                        aria-selected={mapTabsStr === "barChart"}
                        aria-controls="panel-barChart"
                        onClick={(e) => {
                          e.preventDefault();
                          setMapTabsStr("barChart");
                        }}
                      >
                        {getText("Profits", "लाभ")}
                      </a>
                    </li>
                  </ul>
                  <div
                    // className="tab-content"
                    style={animation}
                    key={mapTabsStr}
                  >
                    {/* {mapTabsStr === "pieChart" && <GoogleChart />} */}
                    {mapTabsStr === "pieChart" && <PowerShareChart />}
                    {mapTabsStr === "barChart" && <ProfitChart />}
                    {mapTabsStr === "map" && <GenerationDoughnut />}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 printmap2">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <ul className="nav nav-pills home-customtab">
                    <li className="nav-item">
                      <a
                        title={getText("Power Map", "ऊर्जा मानचित्र")}
                        className={`nav-link ${
                          mapTabsStr1 === "pow" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#hydro"
                        onClick={() => setMapTabsStr1("pow")}
                      >
                        {getText("Power Map", "ऊर्जा मानचित्र")}
                      </a>
                    </li>
                  </ul>
                  <div
                    // className="tab-content"
                    // style={animation}
                    // key={mapTabsStr}
                    aria-labelledby="tab-power"
                  >
                    {/* <!--hydro power section end here--> */}
                    {mapTabsStr1 === "pow" && <NorthEastMap />}
                    {/* {mapTabsStr1 === "pow" && <PowerMapPage />} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartMap;
